export default __webpack_public_path__ + "static/activity-reports-76ff1feb814d51de926e15789e12ba97.mp4";